<template>
  <div class="yk-homework-h-s">
     <div class="yk-comeback-s-new clearfix">
        <div class="yk-ap-que-name">
          <!-- <el-input class="input-with-select" v-model='praname' title='回车完成编辑'  v-if='isShowInput' @blur='hideTitleInput' @keyup.enter.native='hideTitleInput' /> -->
          <div>
            <label> {{praname}} </label>
          </div>
        </div>
        <div class="yk-home-work-score">总分：{{totalscore}}</div>
        <el-button type="primary" @click="backone" icon="wl-icon-fanhui2" class="gobackBtn-brainStorm"></el-button>

    </div>
    <div class="yk-s-homework-questions"  v-for="(item,index) in questionList" :key="index">
      <ul class="yk-hw-question">
        <li :id="index">
          <div class="yk-question-container">
          <header>
            <span class="yk-sequence">{{index+1}}</span>
            <span>{{getQuestionType(item.QuestionType)}}</span>
            <span class="yk-diffcult" disabled :max='3'>难度：{{changedif(item.Difficulty)}}</span>
            <div class="flr">
              <div style="display: inline-block;box-sizing: border-box;vertical-align: -2px;margin-right: 8px;">
                  <label for="">分值：</label>
                  <el-input v-model="item.Score"  min="0" max="100" type="number"  style="width:80px;" disabled="disabled" @blur="blurQuestion(item.Id,item.Score,item.QuestionType,item.sublist.length)"></el-input>
              </div>
            </div>

          </header>
              <Multiselect :IsTitle="false" :IsSelects="false"  :IsAnswers="true" :IsAnalysis="-1"  v-if="item.QuestionType==1 || item.QuestionType==2" :data.sync="item"/>
              <true-false :IsTitle="false" :IsSelects=-1 :IsAnswers="true" :IsAnalysis="-1" v-else-if="item.QuestionType==3" :data.sync="item"/>
              <fillInTheBlanks :IsTitle="false" :IsSelects=-1 :IsAnswers="true" :IsAnalysis="-1"  v-else-if="item.QuestionType==4" :data.sync="item"/>
              <short-answer :IsTitle="false" :IsSelects="false" :IsAnswers="-1" :IsAnalysis="-1"  v-else-if="item.QuestionType==5" :data.sync="item"/>
              <synthesis :IsSelects=-1 :childQuestionList="item.sublist" :IsList="true" :IsTitle="false" v-else-if='item.QuestionType ==6' :data.sync='item'/>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import FillInTheBlanks from "components/school_Homework_bank/FillInTheBlanks_bank.vue";
import Multiselect from "components/school_Homework_bank/Multiselect_bank.vue";
import TrueFalse from "components/school_Homework_bank/TrueFalse_bank.vue";
import ShortAnswer from "components/school_Homework_bank/ShortAnswer_bank.vue";
import QuestionList from "components/school_Homework_bank/QuestionList_bank.vue";
import Synthesis from "components/school_Homework_bank/Synthesis_bank.vue";
export default Vue.extend({
  name: "paper-onnline",
  components: {
    Synthesis,
    // ChangeType,
    TrueFalse,
    ShortAnswer,
    QuestionList,
    Multiselect,
    FillInTheBlanks
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    paperId: {
      type: String,
      default: ""
    },
    paperType: {
      type: String,
      default: "Paper"
    },
    faceId: {
      type: String,
      default: ""
    },
    classId: {
      type: String,
      default: ""
    },
    faceTeachStata: {
      default: ""
    }
  },
  data() {
    return {
      praname: "",
      totalscore: 0,
      condition: "未开始",
      changeCondition: "开始",
      diffcult: 1,
      dialogVisible: false,
      watch: false,
      del: false,
      number: 5,
      questionList: [],
      questionInfo: {},
      checkedIds: [],
      exitIds: [],
      type: ["", "单选题", "多选题", "判断题", "填空题", "简答题", "综合体"],
      deleteId: "",
      AnswerPublishRule: 0,
      ScorePublichRule: 0,
      MultiselectRule: 0,
      FillRule: 0,
      IsTest: false,
      childQuestionList: [],
      routerUrl: "",
      //showshow: false,
      isclear: 0,
      // 用于修改题目标题
      isShowInput: false,
      // 题目数量
      QuestionCount: 0,
      tisi: "确认删除该题目？"
    };
  },
  computed: {
    slected() {
      return `已选${this.checkedIds.length + this.exitIds.length}道题`;
    }
  },
  created() {
    this.getQuestionList();
  },
  watch: {
    dialogVisible: function() {
      if (this.dialogVisible == false) {
        this.isclear = 1;
      }
    }
  },
  methods: {
    //返回上一级
    backone: function() {
      this.$router.go(-1);
    },
    // stretch() {
    //   this.show = !this.show;
    // },
    /*获取题库列表*/
    getQuestionList: function() {
      this.$http.post('/api/XOrg/BookMaterial/getPaperQuestionList',{
        courseId: this.courseId,
        paperId: this.paperId
      }).then(rst => {
        this.questionList = rst.list;
        this.IsTest = rst.IsTest;
        this.praname = rst.paperName;
        this.totalscore = rst.totalscore;
        this.exitIds = [];
        this.QuestionCount = rst.QuestionCount;
        rst.list.forEach(element => {
          this.exitIds.push(element.QuestionId);
        });
        this.AnswerPublishRule = rst.rule.AnswerPublishRule;
        this.ScorePublichRule = rst.rule.ScorePublichRule;
        this.MultiselectRule = rst.rule.MultiselectRule;
        this.FillRule = rst.rule.FillRule;
      });
    },
    getQuestionInfoById: function() {
      this.$http.post('/api/XOrg/BookMaterial/getQuestionInfoById',{
        questionId: this.courseId
      }).then(rst => {
        this.questionInfo = rst.info;
      });
    },
    //获取题目类型
    getQuestionType(QuestionType) {
      if (QuestionType == 1) {
        return "单选题";
      } else if (QuestionType == 2) {
        return "多选题";
      } else if (QuestionType == 3) {
        return "判断题";
      } else if (QuestionType == 4) {
        return "填空题";
      } else if (QuestionType == 5) {
        return "简答题";
      } else {
        return "综合题";
      }
    },
    //难度显示
    changedif(dif) {
      if (dif == 1) {
        return "简单";
      } else if (dif == 2) {
        return "一般";
      } else {
        return "较难";
      }
    },
    goto: function(name, params) {
      if (name === "lectures") {
        this.$router.push({
          name: name,
          params: {
            courseId: this.courseId,
            classId: this.classId,
            faceId: this.faceId,
            classType: this.faceTeachStata
          }
        });
      } else {
        this.$router.push({ name: name, params: params });
      }
    },
    blurQuestion: function(
      id,
      score,
      QuestionType,
      subCount
    ) {
      var isSet = 1;
      if (QuestionType == 6) {
        if (!this.IsExcept(score, subCount)) {
          this.$message.warning("请设置可以平均赋值给予题目的分数");
          isSet = 0;
        }
      }
      if (isSet == 1) {
        if (score > 0 && score <= 100) {
          SetQuestionScore(id, score).then(rst => {
            if (rst.code < 0) {
              this.$message.warning(rst.msg);
            }
          });
        } else {
          this.$message.error("请输入0~100的分数");
        }
      }
    },
    IsExcept: function(m, n) {
      m = parseInt(m.toString().replace(".", ""));
      n = parseInt(n.toString().replace(".", ""));
      while (m % 2 == 0 && m != 0) m = m / 2;
      while (m % 5 == 0 && m != 0) m = m / 5;
      while (n % 2 == 0 && n != 0) n = n / 2;
      while (n % 5 == 0 && n != 0) n = n / 5;

      if (n == 0) return false;
      if (n == 1 || m == 0) return true;
      return m % n == 0;
    }
  }
});
</script>

<style lang="scss">
  .yk-homework-h-s {
    padding-bottom: 50px;
    color:#333;
    .yk-home-work-name {
      float: left;
      padding-top: 10px;
      font-size: 18px;
      // color: #fff;
    }
    .yk-home-work-score {
      float: left;
      padding-left: 30px;
      padding-top: 10px;
      font-size: 18px;
      // color: #fff;
    }

    .yk-comeback-s-new {
      border-bottom: 1px solid #596880;
      background: #fff;
      padding: 20px 39px;
      .yk-ap-que-name {
        float: left;
        font-size: 18px;
        // color: #fff;
        width: 500px;
      }
      .yk-ap-que-btn-back {
        float: right;
      }
      .gobackBtn-brainStorm {
        position: fixed;
        right: 42px;
        top: 70px;
        z-index: 2000;
        padding: 2px 10px;
        .wl-icon-fanhui2 {
          font-size: 29px;
        }
      }
    }
    .yk-comeback:after {
      content: "";
      height: "";
      clear: both;
      display: block;
      visibility: hidden;
    }
    .affix {
      border-bottom: 1px solid #596880;
      background: #374256;
    }
    .get-quetion-list-wrapper {
      // color: #fff;
      border: 1px dashed #fff;
      border-radius: 10px;
      padding: 10px 0;
      text-align: center;
      margin: 0 40px;
      .wl-icon-tianjia {
        margin-right: 10px;
        font-size: 25px;
        border-radius: 50%;
        // border: 1px solid #fff;
        vertical-align: -2px;
      }
      span {
        font-size: 18px;
      }
    }
    .comeback {
      text-decoration: none;
      font-size: 18px;
      // color: #fff;
      line-height: 80px;
      float: left;
      margin-left: 30px;
    }
    .yk-s-workset {
      padding: 0 40px;
      margin: 30px auto;
      margin-top: 20px;
      border-radius: 10px;
      box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.15);
      ul {
        width: 100%;
        list-style: none;
        margin: 0;
        padding: 0;
        // color: #fff;
        border-radius: 10px;
        overflow: hidden;
        li {
          height: 50px;
          width: 100%;
          line-height: 50px;
          padding: 0 30px;
          box-sizing: border-box;
          &:nth-child(even) {
            // background: #415474;
          }
          &:nth-child(odd) {
            // background: #3c4c66;
          }
          .yk-setTitle {
            display: inline-block;
            width: 20%;
          }
          .el-radio {
            width: 20%;
            margin-left: 5%;
            // color: #fff;
          }
          i {
            line-height: 50px;
          }
          .saveSet {
            line-height: 1px;
            height: 30px;
            margin-top: 10px;
            font-size: 16px;
          }
        }
      }
    }
    .yk-s-homework-questions {
      padding: 0 40px;
      margin: 0 auto;
      margin-top: 70px;
      .yk-hw-question {
        list-style: none;
        margin: 0;
        padding: 0;
        li {
          position: relative;
          margin-bottom: 30px;
          border-radius: 10px;
          color: #333;
          background: #fff;
          .yk-question-container {
            //   overflow: hidden;
            height: 100%;
            width: 100%;
          }
          .el-form-item__label{
              color:#333;
          }
          .el-input.is-disabled .el-input__inner{
                background-color: #f5f7fa;
                border-color: #e4e7ed;
                color: #333;
                cursor: not-allowed;
          }
          .yk-table-dark.el-table td{
            background-color: #f5f5f5;
            color: #333;
          }
          .yk-table-dark{
            border-radius: 0;
          }
          header {
            height: 50px;
            width: 100%;
            line-height: 50px;
            padding: 0 16px;
            border-bottom: 1px solid #4c6080;
            font-size: 18px;
            box-sizing: border-box;
            .delete {
              // color: #fff;
              margin-top: 12px;
              background: #cc224e;
              border-color: #cc224e;
              padding: 7px 10px;
              margin-left: 12px;
            }
            .yk-diffcult {
              margin-left: 30px;
            }
            .el-input__inner {
              height: 30px;
              border: none;
            }
            .yk-sequence {
              margin-top: 13px;
              line-height: 22px;
              margin-right: 5px;
              height: 20px;
              font-size: 16px;
              width: 20px;
              border-radius: 50%;
              background: #409EFF;
              text-align: center;
              float: left;
              color: #fff;
            }
          }
          .all-question {
            padding: 0 40px;
            font-size: 18px;
            .timu,
            .yk-analysis {
              margin: 20px 0;
              span {
                float: left;
              }
              .content,
              p {
                margin: 0;
                padding: 0;
                padding-left: 3em;
              }
              .p {
                padding-left: 3em;
                margin: 20px 0;
              }
            }
          }
          .open-analysis {
            position: absolute;
            bottom: -38px;
            left: 50%;
            margin-left: -120px;
            width: 240px;
            font-size: 18px;
            height: 40px;
            border-radius: 0 0 40px 40px;
            line-height: 40px;
            text-align: center;
            background: rgba(63, 88, 128, 0.58);
          }
        }
      }
    }
    .yk-s-homework-questions:first-child {
      margin-top: 30px;
    }
    .bounce-enter-active {
      animation: bounce-in 0.5s;
    }
    .bounce-leave-active {
      animation: bounce-in 0.5s reverse;
    }
    @keyframes bounce-in {
      0% {
        transform: scale(0);
      }
      50% {
        transform: scale(1.5);
      }
      100% {
        transform: scale(1);
      }
    }
    .flr .el-input .el-input__inner {
    // background: rgba(55, 66, 86, 1);
      color: #333;
      font-size: 15px;
    }
    .el-form-item__content,
    .el-form-item__label{
      color:#333 !important;
    }
    .yk-home-tf--wrapper .yk-mm-up-down-wrapper,
    .yk-home-shor-answer-wrapper .yk-mm-up-down-wrapper,
    .yk-home-fill-wrapper .yk-mm-up-down-wrapper,
    .yk-home-syn-que-wrapper .yk-mm-up-down-wrapper{
      background:unset;
    }
    .el-input__inner{
      border-radius: 0;
    }
  }
  .yk-home-mul-wrapper{
    .yk-mm-up-down-wrapper{
      background-color:#edf2f6;
    }
  } 

.dark{
  .yk-homework-h-s {
    padding-bottom: 50px;
    color:#fff;
    .yk-home-work-name {
      float: left;
      padding-top: 10px;
      font-size: 18px;
      // color: #fff;
    }
    .yk-home-work-score {
      float: left;
      padding-left: 30px;
      padding-top: 10px;
      font-size: 18px;
      // color: #fff;
    }

    .yk-comeback-s-new {
      border-bottom: 1px solid #596880;
      width: 100%;
      // background: #374256;
      padding: 20px 39px;
      .yk-ap-que-name {
        float: left;
        font-size: 18px;
        // color: #fff;
        width: 500px;
      }
      .yk-ap-que-btn-back {
        float: right;
      }
      .gobackBtn-brainStorm {
        position: fixed;
        right: 53px;
        top: 10px;
        z-index: 2000;
        padding: 2px 10px;
        .wl-icon-fanhui2 {
          font-size: 29px;
        }
      }
    }
    .yk-comeback:after {
      content: "";
      height: "";
      clear: both;
      display: block;
      visibility: hidden;
    }
    .affix {
      border-bottom: 1px solid #596880;
      background: #374256;
    }
    .get-quetion-list-wrapper {
      // color: #fff;
      border: 1px dashed #fff;
      border-radius: 10px;
      padding: 10px 0;
      text-align: center;
      margin: 0 40px;
      .wl-icon-tianjia {
        margin-right: 10px;
        font-size: 25px;
        border-radius: 50%;
        // border: 1px solid #fff;
        vertical-align: -2px;
      }
      span {
        font-size: 18px;
      }
    }
    .comeback {
      text-decoration: none;
      font-size: 18px;
      // color: #fff;
      line-height: 80px;
      float: left;
      margin-left: 30px;
    }
    .yk-s-workset {
      padding: 0 40px;
      margin: 30px auto;
      margin-top: 20px;
      border-radius: 10px;
      box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.15);
      ul {
        width: 100%;
        list-style: none;
        margin: 0;
        padding: 0;
        // color: #fff;
        border-radius: 10px;
        overflow: hidden;
        li {
          height: 50px;
          width: 100%;
          line-height: 50px;
          padding: 0 30px;
          box-sizing: border-box;
          &:nth-child(even) {
            // background: #415474;
          }
          &:nth-child(odd) {
            // background: #3c4c66;
          }
          .yk-setTitle {
            display: inline-block;
            width: 20%;
          }
          .el-radio {
            width: 20%;
            margin-left: 5%;
            // color: #fff;
          }
          i {
            line-height: 50px;
          }
          .saveSet {
            line-height: 1px;
            height: 30px;
            margin-top: 10px;
            font-size: 16px;
          }
        }
      }
    }
    .yk-s-homework-questions {
      padding: 0 40px;
      margin: 0 auto;
      margin-top: 70px;
      .yk-hw-question {
        list-style: none;
        margin: 0;
        padding: 0;
        li {
          position: relative;
          margin-bottom: 30px;
          border-radius: 10px;
          // color: #fff;
          // background: #3f5880;
          .yk-question-container {
            //   overflow: hidden;
            height: 100%;
            width: 100%;
          }
          header {
            height: 50px;
            width: 100%;
            line-height: 50px;
            padding: 0 16px;
            border-bottom: 1px solid #4c6080;
            font-size: 18px;
            .delete {
              // color: #fff;
              margin-top: 12px;
              background: #cc224e;
              border-color: #cc224e;
              padding: 7px 10px;
              margin-left: 12px;
            }
            .yk-diffcult {
              margin-left: 30px;
            }
            .el-input__inner {
              height: 30px;
              border: none;
            }
            .yk-sequence {
              margin-top: 13px;
              line-height: 22px;
              margin-right: 5px;
              height: 20px;
              font-size: 16px;
              width: 20px;
              border-radius: 50%;
              // background: #fff;
              text-align: center;
              float: left;
              color: #fff;
            }
          }
          .all-question {
            padding: 0 40px;
            font-size: 18px;
            .timu,
            .yk-analysis {
              margin: 20px 0;
              span {
                float: left;
              }
              .content,
              p {
                margin: 0;
                padding: 0;
                padding-left: 3em;
              }
              .p {
                padding-left: 3em;
                margin: 20px 0;
              }
            }
          }
          .open-analysis {
            position: absolute;
            bottom: -38px;
            left: 50%;
            margin-left: -120px;
            width: 240px;
            font-size: 18px;
            height: 40px;
            border-radius: 0 0 40px 40px;
            line-height: 40px;
            text-align: center;
            background: rgba(63, 88, 128, 0.58);
          }
        }
      }
    }
    .yk-s-homework-questions:first-child {
      margin-top: 30px;
    }
    .bounce-enter-active {
      animation: bounce-in 0.5s;
    }
    .bounce-leave-active {
      animation: bounce-in 0.5s reverse;
    }
    @keyframes bounce-in {
      0% {
        transform: scale(0);
      }
      50% {
        transform: scale(1.5);
      }
      100% {
        transform: scale(1);
      }
    }
    .flr .el-input .el-input__inner {
      background: #fff;
      color: #fff;
      font-size: 15px;
    }
    .el-form-item__label{
      color:#000;
    }
    .el-input.is-disabled .el-input__inner{
      color:#000;
    }
    .el-radio__label{
      color:#fff;
    }
  }
}
</style>
